import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-fluid">
          <div className="row">
              <div className="col-sm-6">
                  {new Date().getFullYear()} © <a href="https://innovezasoftware.com/">INNOVEZA BUSINESS SOFTWARE SOLUTIONS.</a>All rights reserved.
              </div>
          </div>
      </div>
    </footer>
  );
};

export default Footer;